export const IN_OUT_BOUND = {
  inbound: "VIEW_INBOUND_FAX",
  outbound: "VIEW_OUTBOUND_FAX",
}

export const FE_URL = "https://demowar.loginbridge.net"
